module.exports = __webpack_public_path__ + "img/shor_yes.ac69177a.png";